import { ReviewsWeeklyDigest } from '@app/model/review/digest/weekly/ReviewsWeeklyDigest';
import React from 'react';
import Utilities from '@util/Utilities';
import Tag from '@app/component/tag/Tag';
import { ReviewsMonthlyDigest } from '@app/model/review/digest/montly/ReviewsMonthlyDigest';
import StateStatisticsForCategory from '@app/model/review/state/StateStatisticsForCategory';


const ReviewsPropertyInsightsCategoryPerformance: React.FunctionComponent<{
	digest: ReviewsWeeklyDigest | ReviewsMonthlyDigest
}> = ({ digest }) => {

	const currentMainHotelState = digest.current?.findMainHotelState();
	const previousMainHotelState = digest.previous?.findMainHotelState();

	if (!currentMainHotelState) {
		return null;
	}

	const currentRootCategoryStats = currentMainHotelState.stateStatisticsForRootCategories;
	const currentCategoryStats = currentRootCategoryStats.length > 0
		? currentRootCategoryStats
		: currentMainHotelState.stateStatisticsForCategories;
	const previousRootCategoryStats = previousMainHotelState?.stateStatisticsForRootCategories ?? [];
	const previousCategoryStats = previousRootCategoryStats.length > 0
		? previousRootCategoryStats
		: previousMainHotelState?.stateStatisticsForCategories;

	const findDiff = (current: StateStatisticsForCategory) => {
		const previous = previousCategoryStats?.find(previousCategory => previousCategory.category.id === current.category.id);
		if (!previous) return undefined;
		return Number(Math.round(current.statistics.score * 10) / 10) - Number(Math.round(previous.statistics.score * 10) / 10);
	}

	return <div className="xl:col-span-6">
		<div className="px-3 mb-1"><h2 className="text-base font-semibold text-gray-900">Category Performance</h2></div>
		<div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm px-4 py-3 sm:px-5 sm:py-4">
			{currentCategoryStats.length === 0 && <div className="py-2 text-sm text-gray-500">
				No category performance data for this period.
			</div>}
			{currentCategoryStats.length > 0 && <ul role="list" className="space-y-3">
				{currentCategoryStats.map((categoryState) => {
					const diff = findDiff(categoryState);
					const score = categoryState.statistics.score ?? 0;
					const scoreWidth = Math.max(0, Math.min(100, score * 10));
					const scoreColor = score >= 9 ? 'bg-green-500' : score >= 8 ? 'bg-blue-500' : 'bg-amber-500';

					return <li className="grid grid-cols-[minmax(0,1fr)_128px_42px_48px] items-center gap-3" key={categoryState.category.id}>
						<div className="min-w-0">
							<p className="truncate text-sm font-medium text-gray-800">{categoryState.category.name}</p>
						</div>
						<div className="h-2 rounded-full bg-gray-100">
							<div className={`${scoreColor} h-2 rounded-full`} style={{ width: `${scoreWidth}%` }} />
						</div>
						<span className="text-right text-sm font-bold text-gray-900">{Utilities.formatDouble(categoryState.statistics.score, 1, "N/A", true)}</span>
							<div className="flex justify-end">
								{diff !== undefined && diff !== 0 && <Tag state={diff > 0 ? "success" : "critical"} extraClassName="px-1.5 py-0.5">{diff > 0 ? "+" : ""}{Utilities.formatDouble(diff, 1)}</Tag>}
							</div>
					</li>
				})}

			</ul>}
		</div>
	</div>

};

export default ReviewsPropertyInsightsCategoryPerformance;
